// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"69":"4418bb8d","879":"3c31c8c6"}[chunkId] + ".chunk.js";
};